import {useMemo} from 'react'
import {useTable, ColumnInstance, Row} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {areawisesColumns} from './columns/_columns'
import {Areawise} from '../core/_models'
import {AreawisesListLoading} from '../components/loading/AreawisesListLoading'
import {AreawisesListPagination} from '../components/pagination/AreawisesListPagination'
import { KTCardBody } from '../../../../../../_metronic/helpers'
//  import { KTCardBody } from '../../../../../_metronic/helpers'
//  import {KTAreawisedBody} from '../../../../../../_metronic/helpers'

const AreawisesTable = () => {
  const areawises = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = useMemo(() => areawises, [areawises])
  const columns = useMemo(() => areawisesColumns, [])
  const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
  })

  return (
    <KTCardBody className='py-4'>
      <div className='table-responsive' >
        <table
          id='kt_table_areawises'
          className='table align-middle table-row-dashed  fs-6 gy-5 dataTable areawise-listing no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start areawisereport-light-secondary fw-bolder fs-6 text-uppercase gs-0'>
              {headers.map((column: ColumnInstance<Areawise>) => (
                <CustomHeaderColumn key={column.id} column={column} />
              ))}
            </tr>
          </thead>
          <tbody className='fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row: Row<Areawise>, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <AreawisesListPagination />
      {isLoading && <AreawisesListLoading />}
    </KTCardBody>
  )
}

export {AreawisesTable}
